<template>
	<div class="app">
		<body>
			<div class="head">
				<h1>智慧消防</h1>
				<div class="outline-header-right" @click="onBackClick">
					<img src="../../../assets/service_center/smartFire/back.png" alt="返回">
				</div>
			</div>
			<div class="mainbox">
				<ul class="clearfix">
					<li>
						<div class="boxall" style="height: 400px">
							<div class="alltitle">报警设备信息</div>

							<div class="sycm">
								<ul class="clearfix">
									<li @click="openPopup(5, '当前报警住户')">
										<h2>{{GetNavDataYHJs.AbTenant}}</h2><span>报警住户数</span>
									</li>
									<li @click="openPopup(4, '当前报警设备')">
										<h2>{{GetNavDataYHJs.abDevice}}</h2><span>报警设备数</span>
									</li>
									
									<li @click="openPopup(1, '设备报警数')">
										<h2>{{GetAbDataCount}}</h2><span>报警总数</span>
									</li>
								</ul>
								<div style="border-bottom: 1px solid rgba(255,255,255,.1)"></div>
								<ul class="clearfix">
									<li @click="openPopup(2, '设备在线列表', '1')">
										<h2>{{GetNavDataYHJs.ZxDevice}}</h2><span>设备在线数</span>
									</li>
									<li @click="openPopup(2, '设备离线列表', '0')">
										<h2>{{GetNavDataYHJs.LxDevice}}</h2><span>设备离线数</span>
									</li>
									<li @click="openPopup(3, '今日已处理', 2)">
										<h2>{{GetNavDataYHJs.todayAbSolve}}</h2><span>今日处理数</span>
									</li>
								</ul>
								<div style="border-bottom: 1px solid rgba(255,255,255,.1)"></div>
								<ul class="clearfix">									
									<li @click="openPopup(3, '今日未处理', 1)">
										<h2>{{GetNavDataYHJs.todayAbWeiSolve}}</h2><span>今日未处理数</span>
									</li>
								</ul>

							</div>
							<div class="boxfoot"></div>
						</div>
						<div class="boxall" style="height: 410px">
							<div class="alltitle">最近报警已处理情况</div>
							<div class="allnav" style="height: 330px" id="myChart"></div>
							<div class="boxfoot"></div>
						</div>
					</li>
					<li>
						<div class="bar">
							<div class="barbox ">
								<ul class="clearfix">
									<li class="pulll_left counter" @click="openPopup(5, '当前报警住户')">{{GetNavDataYHJs.AbTenant}}</li>
									<li class="pulll_left counter" @click="openPopup(4, '当前报警设备')">{{GetNavDataYHJs.abDevice}}</li>
								</ul>
							</div>
							<div class="barbox2">
								<ul class="clearfix">
									<li class="pulll_left" @click="openPopup(5, '当前报警住户')">当前报警住户数</li>
									<li class="pulll_left" @click="openPopup(4, '当前报警设备')">当前报警设备数</li>
								</ul>
							</div>
						</div>
						<div class="bar">
							<div class="barbox">
								<ul class="clearfix">
									<li class="pulll_left counter" @click="openPopup(2, '设备在线列表', '1')">{{GetNavDataYHJs.ZxDevice}}</li>
									<li class="pulll_left counter" @click="openPopup(2, '设备离线列表', '0')">{{GetNavDataYHJs.LxDevice}}</li>
								</ul>
							</div>
							<div class="barbox2">
								<ul class="clearfix">
									<li class="pulll_left" @click="openPopup(2, '设备在线列表', '1')">当前设备在线数</li>
									<li class="pulll_left" @click="openPopup(2, '设备离线列表', '0')">当前设备离线数</li>
								</ul>
							</div>
						</div>
						<div class="map">
							<div class="map1"><img src="../../../assets/service_center/smartFire/lbx.png"></div>
							<div class="map2"><img src="../../../assets/service_center/smartFire/jt.png"></div>
							<div class="map3"><img src="../../../assets/service_center/smartFire/map.png"></div>
							<div class="map4" id="map_1"></div>
						</div>
						<div class="boxall" style="height: 240px">
							<div class="alltitle">最近报警条目列表</div>
							<div class="allnav" id="wrapper2" style="height: 170px; overflow: hidden;">
								<ul id="content2" class="outline-left-lists">
									<li class="clearfix3" v-for="(item, index) in GetAbDataLists" :key="index">
										<span class="pulll_left3">{{item.DeviceCode}}</span>
										<span class="pulll_center3">{{item.UserDeviceName}}</span>
										<span class="pulll_right3_1">{{item.AbnormalName}}</span>
										<span class="pulll_right3">{{item.AbnormalTime}}</span>
									</li>
								</ul>
								<ul id="fakeContent2" v-if="GetAbDataLists.length > 4"></ul>
								<div class="map-right-group-list-none" v-if="GetAbDataLists.length==0">暂无报警</div>
							</div>
							<div class="boxfoot"></div>
						</div>
					</li>
					<li>
						<div class="boxall" style="height:570px">
							<div class="alltitle">设备状态</div>
							<div class="clearfix">
								<div class="sy" style="width:100%;" id="myChart1"></div>
							</div>
							<div class="addnew">
								<div class="tit02"><span>设备列表</span></div>
								<div class="adduser" id="wrapper" style="height: 200px">
									<ul id="content" v-if="GetDeviceDataLists.length > 0">
										<li v-for="(item, index) in GetDeviceDataLists" :key="index" class="clearfix">
											<span class="pulll_left"
												:title="item.CommunityName">{{item.CommunityName}}</span>
											<span class="pulll_center">{{item.UserDeviceName}}</span>
											<span class="pulll_right">
												<span v-if="item.SwitchStatus == 1">合闸</span>
												<span v-else-if="item.SwitchStatus == 2">分闸</span>
												<span v-else>--</span>
											</span>
										</li>
									</ul>
									<ul id="fakeContent" v-if="GetDeviceDataLists.length > 4"></ul>
									<div class="map-right-group-list-none" v-if="GetDeviceDataLists.length == 0">暂无设备信息
									</div>
								</div>
							</div>
							<div class="boxfoot"></div>
						</div>
						<div class="boxall" style="height: 240px">
							<div class="alltitle">操作日志</div>
							<div class="adduser" style="height: 170px">
								<ul class="outline-left-lists" style="overflow-y: auto;height: 170px"
									v-if="GetOperationDataList.length > 0">
									<li v-for="(item, index) in GetOperationDataList" :key="index" class="clearfix">
										<span class="pulll_left2">{{item.CreateTime}}</span>
										<span class="pulll_center2">{{item.UserDeviceName}}</span>
										<span class="pulll_right2">{{item.Remark}}</span>
									</li>
								</ul>
								<div class="map-right-group-list-none" v-else>暂无操作日志</div>
							</div>

							<div class="boxfoot"></div>
						</div>
					</li>
				</ul>

			</div>
			<div class="back"></div>
			<div class="outline-view" v-if="popupState" @click="shutDown('self')">
				<div class="outline-top" @click.stop="shutDown()">
					<dv-border-box-11 backgroundColor="rgba(7,22,55, 0.7)" :title="popupTitle">
						<div class="outline-remove" @click="shutDown('self')">
							<img src="../../../assets/service_center/home/remove.png" alt="">
						</div>
						<div class="outline-mode">
							<template v-if="popupType == 1">
								<div class="map-bottom-content-tab">
									<div class="map-bottom-content-tab-item">设备名称</div>
									<div class="map-bottom-content-tab-item">设备编号</div>
									<div class="map-bottom-content-tab-item">时间</div>
									<div class="map-bottom-content-tab-item">类型</div>
									<div class="map-bottom-content-tab-item tabHandle">操作</div>
								</div>
								<div class="map-bottom-list">
									<div id="content" class="map-bottom-lists" v-if="DeviceAbnormalList.length > 0">
										<div class="map-bottom-list-item" v-for="item in DeviceAbnormalList" :key="item.Id">
											<div class="map-bottom-list-item-device">{{item.UserDeviceName}}</div>
											<div class="map-bottom-list-item-addr">{{item.DeviceCode}}</div>
											<div class="map-bottom-list-item-date">{{item.AbnormalTime}}</div>
											<div class="map-bottom-list-item-type">{{item.AbnormalName}}</div>
											<div class="map-bottom-list-item-handle">
												<div class="ivu-dropdown">
													<div class="" style="margin-top: 0.1vw;">
														<div class="map-bottom-list-item-handle-btn">
															<Dropdown trigger="click" style="width: 5vw;">
																<a href="javascript:void(0)">
																	请处理
																	<Icon type="md-arrow-dropdown" style="margin-left: 0.5vw;" />
																</a>
																<DropdownMenu slot="list" style="width: 5vw;">
																	<DropdownItem @click.native="SolveAbData(item.Id, 2, 109)">处理</DropdownItem>
																	<DropdownItem @click.native="SolveAbData(item.Id, 3, 109)">误报</DropdownItem>
																</DropdownMenu>
															</Dropdown>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="map-right-group-list-none" v-if="DeviceAbnormalList.length == 0">暂无告警消息</div>
								</div>
								<div class="user-top-list-page">
									<Page :total="DeviceAbnormalTotalCount" @on-change="DeviceAbnormalChange" @on-page-size-change="DeviceAbnormalSizeChange" size="small" show-total show-elevator show-sizer placement="top" />
								</div>
							</template>
							<template v-else-if="popupType == 2">
								<div class="map-bottom-content-tab">
									<div class="map-bottom-content-tab-item">设备名称</div>
									<div class="map-bottom-content-tab-item">设备编号</div>
									<div class="map-bottom-content-tab-item">设备地址</div>
									<div class="map-bottom-content-tab-item">通讯时间</div>
									<div class="map-bottom-content-tab-item tabHandle">设备状态</div>
								</div>
								<div class="map-bottom-list">
									<div id="content" class="map-bottom-lists" v-if="DeviceLists.length > 0">
										<div class="map-bottom-list-item" v-for="item in DeviceLists" :key="item.Id">
											<div class="map-bottom-list-item-device">{{item.UserDeviceName}}</div>
											<div class="map-bottom-list-item-addr">{{item.DeviceCode}}</div>
											<div class="map-bottom-list-item-date">{{item.CommunityName}}</div>
											<div class="map-bottom-list-item-date">{{item.UpdateTime}}</div>
											<div class="map-bottom-list-item-handle">{{item.SwitchStatus == 1 ? '合闸' : item.SwitchStatus == 2 ? '分闸' : '--'}}</div>
										</div>
									</div>
									<div class="map-right-group-list-none" v-if="DeviceLists.length == 0">暂无设备</div>
								</div>
								<div class="user-top-list-page">
									<Page :total="DeviceTotal" @on-change="DeviceChange" @on-page-size-change="DeviceSizeChange" size="small" show-total show-elevator show-sizer placement="top" />
								</div>
							</template>
							<template v-else-if="popupType == 3">
								<div class="map-bottom-content-tab">
									<div class="map-bottom-content-tab-item">设备名称</div>
									<div class="map-bottom-content-tab-item">设备编号</div>
									<div class="map-bottom-content-tab-item">时间</div>
									<div class="map-bottom-content-tab-item">类型</div>
									<div class="map-bottom-content-tab-item tabHandle">操作</div>
								</div>
								<div class="map-bottom-list">
									<div id="content" class="map-bottom-lists" v-if="DeviceAbnormalList.length > 0">
										<div class="map-bottom-list-item" v-for="item in DeviceAbnormalList" :key="item.Id">
											<div class="map-bottom-list-item-device">{{item.UserDeviceName}}</div>
											<div class="map-bottom-list-item-addr">{{item.DeviceCode}}</div>
											<div class="map-bottom-list-item-date">{{item.AbnormalTime}}</div>
											<div class="map-bottom-list-item-type">{{item.AbnormalName}}</div>
											<div class="map-bottom-list-item-handle">
												<template v-if="DeviceCategory == 1">
													<div class="ivu-dropdown">
														<div class="" style="margin-top: 0.1vw;">
															<div class="map-bottom-list-item-handle-btn">
																<Dropdown trigger="click" style="width: 5vw;">
																	<a href="javascript:void(0)">
																		请处理
																		<Icon type="md-arrow-dropdown" style="margin-left: 0.5vw;" />
																	</a>
																	<DropdownMenu slot="list" style="width: 5vw;">
																		<DropdownItem @click.native="SolveAbData(item.Id, 2, 109)">处理</DropdownItem>
																		<DropdownItem @click.native="SolveAbData(item.Id, 3, 109)">误报</DropdownItem>
																	</DropdownMenu>
																</Dropdown>
															</div>
														</div>
													</div>
												</template>
												<template v-else-if="DeviceCategory == 2">
													已处理
												</template>
												<template v-else>
													误报
												</template>
											</div>
										</div>
									</div>
									<div class="map-right-group-list-none" v-if="DeviceAbnormalList.length == 0">暂无告警消息</div>
								</div>
								<div class="user-top-list-page">
									<Page :total="DeviceAbnormalTotalCount" @on-change="DeviceAbnormalChange1" @on-page-size-change="DeviceAbnormalSizeChange1" size="small" show-total show-elevator show-sizer placement="top" />
								</div>
							</template>
							<template v-else-if="popupType == 4">
								<div class="map-bottom-content-tab">
									<div class="map-bottom-content-tab-item">设备名称</div>
									<div class="map-bottom-content-tab-item">设备编号</div>
									<div class="map-bottom-content-tab-item">设备地址</div>
									<div class="map-bottom-content-tab-item">在线状态</div>
									<div class="map-bottom-content-tab-item tabHandle">设备状态</div>
								</div>
								<div class="map-bottom-list" style="height: calc(100% - 1.75vw);">
									<div id="content" class="map-bottom-lists" v-if="DeviceCountList.length > 0">
										<div class="map-bottom-list-item" v-for="item in DeviceCountList" :key="item.Id">
											<div class="map-bottom-list-item-device">{{item.UserDeviceName}}</div>
											<div class="map-bottom-list-item-addr">{{item.DeviceCode}}</div>
											<div class="map-bottom-list-item-date">{{item.Address}}</div>
											<div class="map-bottom-list-item-date">{{item.IsOnline ? '在线' : '离线'}}</div>
											<div class="map-bottom-list-item-handle">{{item.SwitchStatus == 1 ? '合闸' : item.SwitchStatus == 2 ? '分闸' : '--'}}</div>
										</div>
									</div>
									<div class="map-right-group-list-none" v-if="DeviceCountList.length == 0">暂无告警消息</div>
								</div>
							</template>
							<template v-else-if="popupType == 5">
								<div class="map-bottom-content-tab">
									<div class="map-bottom-content-tab-item">所属小区</div>
									<div class="map-bottom-content-tab-item">住户地址</div>
									<div class="map-bottom-content-tab-item">业主名称</div>
									<div class="map-bottom-content-tab-item">联系电话</div>
									<div class="map-bottom-content-tab-item">报警时间</div>
								</div>
								<div class="map-bottom-list" style="height: calc(100% - 1.75vw);">
									<div id="content" class="map-bottom-lists" v-if="GetCurrRoomAbLists.length > 0">
										<div class="map-bottom-list-item" v-for="item in GetCurrRoomAbLists" :key="item.Id">
											<div class="map-bottom-list-item-device">{{item.VName}}</div>
											<div class="map-bottom-list-item-addr">{{`${item.Zhuang}幢-${item.Unit}单元-${item.Floor}楼-${item.RoomNo}房间`}}</div>
											<div class="map-bottom-list-item-date">{{item.OwnerName}}</div>
											<div class="map-bottom-list-item-date">{{item.OwnerPhone}}</div>
											<div class="map-bottom-list-item-date">{{item.CreateDate}}</div>
										</div>
									</div>
									<div class="map-right-group-list-none" v-if="GetCurrRoomAbLists.length == 0">暂无告警住户</div>
								</div>
							</template>
						</div>
			
					</dv-border-box-11>
				</div>
			</div>
		</body>

	</div>
</template>

<script>
	import Echarts from 'echarts'
	import Cookies from 'js-cookie'
	import $ from 'jquery'
	import api from '../../../api/yhj_request.js'
	export default {
		data() {
			return {
				GetNavDatas: {}, // 导航栏数据（旧）
				GetNavDataYHJs: {}, // 导航栏数据
				processed: 0, // 今日已处理数量
				GetDeviceDataLists: [], // 设备相关数据列表
				GetOperationDataList: [], // 当天操作日志数据列表
				GetAbDataLists: [], // 及时告警消息列表
				GetAbDataCount: 0, // 报警总数
				timer: null,
				timer2: null,
				timertmpe: false, // 滑动状态
				
				popupState: false, // 弹窗状态
				popupType: 0, // 弹窗类型
				popupTitle: "", // 弹窗title
				pageIndex: 1,
				pageSize: 10,
				DeviceLists: [], // 设备列表
				DeviceTotal: 0, // 设备数量
				DeviceCategory: '',
				DeviceAbnormalList: [], // 报警列表
				DeviceAbnormalTotalCount: 0, // 报警数量
				DeviceCountList: [], // 当前报警设备
				GetCurrRoomAbLists: [], // 当前报警住户
				
			}
		},

		computed: {

		},

		mounted() {
			let _this = this;
			
			// 获取导航栏数据
			// _this.GetNavData();
			
			// 获取导航栏数据（yhj）
			_this.GetNavDataYHJ();

			// 告警异常处理情况图表数据
			_this.GetEchartAbData();

			// 图表在线离线数据（yhj）
			_this.GetDeviceZLData();

			// 根据集团 公司 部门编号 等条件查询设备列表
			_this.GetUserDevicesPage();

			// 当天操作日志数据（yhj）
			_this.GetOperationData();

			// 根据集团 公司 部门获取设备异常（yhj）
			_this.GetDeviceAbnormalPageListWith3Code();

		},

		methods: {
			// 获取导航栏数据
			GetNavData() {
				let _this = this;
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/Device/GetNavData`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}).then(function(res) {
					if (res.Success) {
						_this.GetNavDatas = res.Data;
					}
				}).catch(function(err) {});
			},
			// 获取导航栏数据（yhj）
			GetNavDataYHJ() {

				if (!Cookies.get('yhjAdminData')) {
					return;
				}
				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));

				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetNavData?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&isAdmin=${yhjAdminData.IsAdmin}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}, 'yhj').then(function(res) {
					if (res.Success) {

						_this.GetNavDataYHJs = res.Data;

						// _this.getNumScroll(_this.GetNavDataYHJs);

					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				})
			},

			// 根据集团 公司 部门获取设备异常（yhj）
			GetDeviceAbnormalPageListWith3Code() {

				if (!Cookies.get('yhjAdminData')) {
					return;
				}

				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&pageIndex=1&pageSize=100&pstate=1`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken') ? Cookies.get('yhjToken') : ''
					}
				}, 'yhj').then(function(res) {
					if (res.Success) {

						_this.GetAbDataLists = res.Data;
						_this.GetAbDataCount = res.TotalCount;
						
						if (!_this.timertmpe) {
							_this.$nextTick(function() {
								_this.timertmpe = true;
								_this.Carousel2();
							});
						}
						

					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				})
			},

			// 告警异常处理情况图表数据
			GetEchartAbData() {
				if (!Cookies.get('yhjAdminData')) {
					return;
				}

				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetEchartAbData?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&isAdmin=${yhjAdminData.IsAdmin}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}, 'yhj').then(function(res) {

					if (res.Success) {

						let series = [],
							legends = [];
						res.Data.forEach((item, index) => {
							series.push({
								value: item.value,
								name: item.name,
								itemStyle: {
									color: index === 0 ? '#2094DF' : index === 1 ? '#2AEED0' :
										'#8256F3'
								}
							})
							legends.push(item.name);

							if (item.name == '已处理') {
								_this.processed = item.value
							}
						})

						if (series.length == 0) {
							series = [], legends = [];
							series.push({
								value: 0,
								name: '已处理',
								itemStyle: {
									color: '#2094DF'
								}
							})
							legends.push('已处理');

							_this.processed = 0
						}


						_this.$nextTick(function() {
							_this.drawLine(legends, series);
						});

					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}).catch(function(err) {
					// if (err.data.Code == -9 || err.data.Code == -1) {
					// 	_this.$router.push({
					// 		name: 'login'
					// 	})
					// }
				});
			},

			drawLine(legends, series) {
				let _this = this;
				if (!document.getElementById('myChart')) return;
				// 基于准备好的dom，初始化echarts实例
				let myChart = Echarts.init(document.getElementById('myChart'))
				// 绘制图表
				myChart.setOption({
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b} : {c} ({d}%)'
					},
					legend: {
						bottom: 10,
						textStyle: {
							color: '#ffffff',
						},
						left: 'center',
						data: legends
					},
					series: [{
						name: '处理情况',
						type: 'pie',
						label: {
							// normal: {
							// 	position: 'inner',
							// 	show: false
							// },
							formatter: '{b}: {c} ({d}%)'
						},
						radius: '50%',
						center: ['50%', '50%'],
						data: series,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				});
				window.addEventListener('resize', function() {
					myChart.resize()
				})
				// 饼图点击跳转到指定页面
				myChart.on('click', function(param) {
					_this.openPopup(3, param.name == '已处理' ? '今日已处理' : param.name == '未处理' ? '今日未处理' : '今日误报',
						param.name ==
						'已处理' ? '2' : param.name == '未处理' ? '1' : '3')
				});
			},

			// 图表在线离线数据（yhj）
			GetDeviceZLData() {
				if (!Cookies.get('yhjAdminData')) {
					return;
				}

				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetDeviceZLData?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&isAdmin=${yhjAdminData.IsAdmin}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}, 'yhj').then(function(res) {
					if (res.Success) {

						let series = [];
						res.Data.forEach((item, index) => {
							series.push({
								value: item.value,
								name: item.name,
								itemStyle: {
									color: index === 0 ? '#8256F3' : '#2AEED0'
								}
							})
						})
						_this.$nextTick(function() {
							_this.myChart1(series);
						});

					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}).catch(function(err) {
					// if (err.data.Code == -9 || err.data.Code == -1) {
					// 	_this.$router.push({
					// 		name: 'login'
					// 	})
					// }
				});
			},

			myChart1(series) {
				let _this = this;
				if (!document.getElementById('myChart1')) return;
				// 基于准备好的dom，初始化echarts实例
				let myChart = Echarts.init(document.getElementById('myChart1'))
				// 绘制图表
				myChart.setOption({
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b}: {c} ({d}%)'
					},

					series: [{
						name: '设备状态',
						type: 'pie',
						radius: ['40%', '60%'],
						label: {
							formatter: '{b}: {c} ({d}%)'
						},
						data: series
					}]
				});

				window.addEventListener('resize', function() {
					myChart.resize()
				})

				// 饼图点击跳转到指定页面
				myChart.on('click', function(param) {
					_this.openPopup(2, param.name == '在线' ? '设备在线列表' : '设备离线列表', param.name == '在线' ? '1' : '0')
				});

			},

			// 根据集团 公司 部门编号 等条件查询设备列表
			GetUserDevicesPage() {

				if (!Cookies.get('yhjAdminData')) {
					return;
				}

				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));

				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetUserDevicesPage?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&pageIndex=1&pageSize=100`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}, 'yhj').then(function(res) {

					if (res.Success) {
						_this.GetDeviceDataLists = res.Data;
						_this.$nextTick(function() {
							_this.Carousel();
						});
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}).catch(function(err) {

				});
			},

			// 当天操作日志数据（yhj）
			GetOperationData() {
				if (!Cookies.get('yhjAdminData')) {
					return;
				}

				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetOperationData?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&isAdmin=${yhjAdminData.IsAdmin}&pageIndex=1&pageSize=100`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}, 'yhj').then(function(res) {
					if (res.Success) {

						_this.GetOperationDataList = res.Data;

					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}).catch(function(err) {
					// if (err.data.Code == -9 || err.data.Code == -1) {
					// 	_this.$router.push({
					// 		name: 'login'
					// 	})
					// }
				});
			},

			Carousel() {
				this.roll(50);
			},

			roll(t) {

				var content = document.getElementById("content");
				var fakeContent = document.getElementById("fakeContent");
				var wrapper = document.getElementById("wrapper");

				let _this = this;

				if (!content) {
					return;
				}

				fakeContent.innerHTML = content.innerHTML;
				// 开始无滚动时设为0
				wrapper.scrollTop = 0;

				this.timer = null;

				//鼠标事件绑定
				$('#wrapper').hover(function() {
					clearInterval(this.timer);
					this.timer = null
				}, function() {
					this.timer = setInterval(() => {
						_this.rollStart(wrapper, content)
					}, t);
				}).mouseout();

			},

			// 开始滚动函数
			rollStart(wrapper, content) {
				// 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
				if (wrapper.scrollTop >= content.scrollHeight) {
					wrapper.scrollTop = 0;
				} else {
					wrapper.scrollTop++;
				}
			},

			// 轮播2
			Carousel2() {
				this.roll2(50);
			},

			roll2(t) {

				let content = document.getElementById("content2");
				let fakeContent = document.getElementById("fakeContent2");
				let wrapper = document.getElementById("wrapper2");

				let _this = this;

				if (!content) {
					return;
				}

				$('#fakeContent2').html($('#content2').html());

				// 开始无滚动时设为0
				wrapper.scrollTop = 0;

				this.timer2 = null;

				//鼠标事件绑定
				$('#wrapper2').hover(function() {
					clearInterval(this.timer2);
					this.timer2 = null
				}, function() {
					this.timer2 = setInterval(() => {
						_this.rollStart2(wrapper, content)
					}, t);
				}).mouseout();

			},

			// 开始滚动函数二
			rollStart2(wrapper, content) {
				// 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
				if (wrapper.scrollTop >= content.scrollHeight) {
					wrapper.scrollTop = 0;
				} else {
					wrapper.scrollTop++;
				}
			},
			
			// 返回主页
			onBackClick() {
				let _this = this;
				
				// 清除储存后台返回位置
				Cookies.set('yhjCityName', '');
									
				// 清除token
				Cookies.set('yhjToken', '');
									
				// 清除集团部门编号
				Cookies.set('yhjAdminData', {});
									
				// 清除登录名
				Cookies.set('yhjUserLogin', '');
				_this.$router.push({
					name: 'index'
				})
			},
			
			// 开启弹窗
			openPopup(type, title, category = '') {
				let _this = this;
				_this.popupState = true;
				_this.popupType = type;
				_this.popupTitle = title;
				_this.pageIndex = 1;
				_this.pageSize = 10;
			
				if (type == 1) {
					_this.getDeviceAbnormalPages()
				} else if (type == 2) {
					_this.DeviceCategory = category;
					_this.getUserDevicesPages()
				} else if (type == 3) {
					_this.DeviceCategory = category;
					_this.getThatDayDeviceAbnormalPages();
				} else if (type == 4) {
					_this.GetCurrRoomAbDevices();
				} else if (type == 5) {
					_this.GetCurrRoomAbList();
				}
			
			},
			
			// 根据集团 公司 部门编号 等条件查询设备列表
			getUserDevicesPages() {
				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetUserDevicesPage?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&pageIndex=${_this.pageIndex}&pageSize=${_this.pageSize}&onlineState=${_this.DeviceCategory}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}, 'yhj').then(function(res) {
					if (res.Success) {
						_this.DeviceLists = res.Data;
						_this.DeviceTotal = res.TotalCount;
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}).catch(function(err) {
			
				});
			},
			DeviceChange(e) {
				let _this = this;
				_this.pageIndex = e;
				_this.getUserDevicesPages()
			},
			DeviceSizeChange(e) {
				let _this = this;
				_this.pageIndex = 1;
				_this.pageSize = e;
				_this.getUserDevicesPages()
			},
			
			// 根据集团 公司 部门获取设备异常（yhj）
			getDeviceAbnormalPages() {
				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&pageIndex=${_this.pageIndex}&pageSize=${_this.pageSize}&pstate=1`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken') ? Cookies.get('yhjToken') : ''
					}
				}, 'yhj').then(function(res) {
					if (res.Success) {
			
						_this.DeviceAbnormalList = res.Data;
						_this.DeviceAbnormalTotalCount = res.TotalCount;
			
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				})
			},
			DeviceAbnormalChange(e) {
				let _this = this;
				_this.pageIndex = e;
				_this.getDeviceAbnormalPages()
			},
			DeviceAbnormalSizeChange(e) {
				let _this = this;
				_this.pageIndex = 1;
				_this.pageSize = e;
				_this.getDeviceAbnormalPages()
			},
			
			//
			getThatDayDeviceAbnormalPages() {
				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
			
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/YhjStatic/GetDeviceAbnormalPageListWith3Code?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&pageIndex=${_this.pageIndex}&pageSize=${_this.pageSize}&pstate=${_this.DeviceCategory}&startDt=${_this.getNowFormatDate(new Date())}&endDt=${_this.getNowFormatDate(new Date())}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken') ? Cookies.get('yhjToken') : ''
					}
				}, 'yhj').then(function(res) {
					if (res.Success) {
			
						_this.DeviceAbnormalList = res.Data;
						_this.DeviceAbnormalTotalCount = res.TotalCount;
			
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				})
			},
			DeviceAbnormalChange1(e) {
				let _this = this;
				_this.pageIndex = e;
				_this.getThatDayDeviceAbnormalPages()
			},
			DeviceAbnormalSizeChange1(e) {
				let _this = this;
				_this.pageIndex = 1;
				_this.pageSize = e;
				_this.getThatDayDeviceAbnormalPages()
			},
			
			// 获取日期
			getNowFormatDate(date) {
				let seperator1 = "-";
				let year = date.getFullYear();
				let month = date.getMonth() + 1;
				let strDate = date.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				let currentdate = year + seperator1 + month + seperator1 + strDate;
				return currentdate;
			},
			
			// 获取告警设备列表
			GetCurrRoomAbDevices() {
				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
			
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetCurrRoomAbDevices?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&isAdmin=${yhjAdminData.IsAdmin}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken') ? Cookies.get('yhjToken') : ''
					}
				}, 'yhj').then(function(res) {
			
					_this.DeviceCountList = res;
			
				})
			},
			
			// 当前报警住户列表
			GetCurrRoomAbList() {
				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
			
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/CommElecDevice/GetCurrRoomAbList?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&isAdmin=${yhjAdminData.IsAdmin}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken') ? Cookies.get('yhjToken') : ''
					}
				}, 'yhj').then(function(res) {
			
					_this.GetCurrRoomAbLists = res;
			
				})
			},
			
			// 及时告警信息处理 type 1、处理 2、误报（yhj）
			SolveAbData(Id, type, state) {
				let _this = this,
					yhjAdminData = JSON.parse(Cookies.get('yhjAdminData'));
				api({
					//这里是你自己的请求方式、url和data参数
					method: 'get',
					url: `api/YhjDevice/ProcessUserDeviceAbnormal?groupCode=${yhjAdminData.GroupCode}&companyCode=${yhjAdminData.CompanyCode}&departmentCode=${yhjAdminData.DepartmentCode}&userDeviceAbnormal_Id=${Id}&pstate=${type}`,
					data: {},
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('yhjToken')
					}
				}, 'yhj').then(function(res) {
					if (res.Success) {
						_this.$Message['success']({
							background: true,
							content: res.Message
						});
			
						// 根据集团 公司 部门获取设备异常（yhj）
						_this.GetDeviceAbnormalPageListWith3Code();
			
						// 获取导航栏数据（yhj）
						_this.GetNavDataYHJ();
			
						// 告警异常处理情况图表数据
						_this.GetEchartAbData();
			
						if (_this.popupType == 1) {
							//
							_this.getDeviceAbnormalPages()
						} else if (_this.popupType == 3) {
							_this.getThatDayDeviceAbnormalPages();
						}
			
			
					} else {
						_this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				}).catch(function(err) {
					// _this.$Message['error']({
					//   background: true,
					//   content: '请求超时'
					// });
				});
			},
			// 关闭弹窗
			shutDown(type) {
				if (type == 'self') {
					let _this = this;
					_this.popupState = false;
				}
			}

		}
	}
</script>

<style scoped>
	.outline-left>>>.ivu-spin-fix,
	.outline-right>>>.ivu-spin-fix {
		background-color: rgba(12, 63, 136, 0.3);
	}
	
	.user-top-list-page>>>.ivu-page-item,
	.user-top-list-page>>>.ivu-page-prev,
	.user-top-list-page>>>.ivu-page-next,
	.user-top-list-page>>>.ivu-select-selection,
	.user-top-list-page>>>.ivu-page-options-elevator input {
		background-color: rgba(255, 255, 255, 0);
		min-width: 1.2vw;
		height: 1.2vw;
		line-height: 1.2vw;
		border-radius: 3px;
	}
	
	.user-top-list-page>>>.ivu-page-item>a,
	.user-top-list-page>>>.ivu-page-options-elevator input {
		color: rgb(200, 200, 200);
		font-size: 0.6vw;
	}
	
	.user-top-list-page>>>.ivu-page-item-active a,
	.ivu-page-item-active:hover a {
		color: #2d8cf0;
	}
	
	.user-top-list-page>>>.ivu-select-selection,
	.user-top-list-page>>>.ivu-page-options-elevator input {
		border: 0.05vw solid rgba(255, 255, 255, 0.2);
	}
	
	.user-top-list-page>>>.ivu-select-selected-value,
	.user-top-list-page>>>.ivu-page-options-elevator, 
	.user-top-list-page>>>.ivu-page-total {
		color: rgba(255, 255, 255, 0.6);
	}
	
	
	#app>>>.ivu-dropdown-menu {
		width: 5vw;
		min-width: 5vw;
	}
	
	#app>>>.ivu-dropdown-item {
		padding: 0.35vw 0.7vw;
		font-size: 0.7vw !important;
	}
</style>
<style src="./smart_fire.css" scoped="scoped">
	.grid {
		margin-top: 5%;
		width: 80%;
		height: 10px;
		display: grid;
		grid-template-columns: repeat(20, 1fr);
		grid-column-gap: 14px;
	}

	.line {
		position: relative;
		width: 90%;
		height: 7px;
	}

	.line::before,
	.line::after {
		content: '';
		position: absolute;
		width: 450px;
		height: 100%;
		border-radius: 7px;
		background-color: #FF0000;
	}

	.line::before {
		animation: first-line ease-in-out 4s var(--delay) infinite alternate;
	}

	.line::after {
		bottom: 0;
		background-color: #B22222;
		width: calc(80% - 10px);
		animation: second-line ease-in-out 4s var(--delay) infinite alternate;
	}

	.line:nth-child(1) {
		--delay: calc(-0.1s);
	}


	@keyframes first-line {
		70% {
			width: calc(80% - 10px);
		}

		100% {
			background-color: #FF0000;
		}
	}
</style>
